/* import __COLOCATED_TEMPLATE__ from './number-filter.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import {
  type Filter,
  Operator,
  type Predicate,
} from 'embercom/components/standalone/salesforce/setup/article-sync/steps/filter';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import type IntlService from 'ember-intl/services/intl';

interface Args {
  filter: Filter;
  index: number;
  removeFilter: (index: number) => void;
  setPredicate: (predicate: Predicate, index: number) => void;
}

export default class StandaloneSalesforceSetupArticleSyncFilterItemsNumberFilter extends Component<Args> {
  @service declare intl: IntlService;

  @tracked selectedOperator = this.initialSelectedOperator;
  @tracked value = this.initialValue;

  get initialSelectedOperator() {
    if (this.args.filter.predicate.operator === undefined) {
      return Operator.Equal;
    }

    return this.args.filter.predicate.operator;
  }

  get initialValue() {
    if (this.args.filter.predicate.value === undefined) {
      return 0;
    }

    return this.args.filter.predicate.value as number;
  }

  get predicate() {
    return {
      ...this.args.filter.predicate,
      operator: this.selectedOperator,
      value: this.value,
    };
  }

  get radioButtons() {
    return [
      {
        label: this.intl.t(
          'standalone.salesforce.setup.article-sync.steps.filter.operators.equals',
        ),
        value: Operator.Equal,
      },
      {
        label: this.intl.t(
          'standalone.salesforce.setup.article-sync.steps.filter.operators.not-equals',
        ),
        value: Operator.NotEqual,
      },
      {
        label: this.intl.t(
          'standalone.salesforce.setup.article-sync.steps.filter.operators.greater-than',
        ),
        value: Operator.GreaterThan,
      },
      {
        label: this.intl.t(
          'standalone.salesforce.setup.article-sync.steps.filter.operators.less-than',
        ),
        value: Operator.LessThan,
      },
      {
        label: this.intl.t(
          'standalone.salesforce.setup.article-sync.steps.filter.operators.greater-than-equal',
        ),
        value: Operator.GreaterThanOrEqual,
      },
      {
        label: this.intl.t(
          'standalone.salesforce.setup.article-sync.steps.filter.operators.less-than-equal',
        ),
        value: Operator.LessThanOrEqual,
      },
    ];
  }

  get filterBlockDetails() {
    return `${this.selectedOperator} ${this.value}`;
  }

  @action
  onClose() {
    this.args.setPredicate(this.predicate, this.args.index);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Salesforce::Setup::ArticleSync::FilterItems::NumberFilter': typeof StandaloneSalesforceSetupArticleSyncFilterItemsNumberFilter;
    'standalone/salesforce/setup/article-sync/filter-items/number-filter': typeof StandaloneSalesforceSetupArticleSyncFilterItemsNumberFilter;
  }
}
